import axios from "axios";
import {
  Category,
  Page,
  TypeOfSelection,
  PriceRevers,
  ProductAnalysis,
  State,
  PriceRange,
  SelectedCompany,
  DateFilter,
  StartingDateFilter,
  EndingDateFilter,
  ProductStatus,
  ListingScope,
} from "../../../components/Marketplace/Marketplace";
import { search } from "../../../components/Layouts/AdminHeader";
import {
  product_Fail,
  product_Request,
  product_Success,
} from "../../reduser/MarketPlace/Product-Filter";

/** When set (incl. empty string), AllProducts uses this instead of header `search` (e.g. Live Products page). */
let productListingSearchOverride;
export const setProductListingSearchOverride = (value) => {
  if (value === undefined) productListingSearchOverride = undefined;
  else productListingSearchOverride = String(value);
};

/**
 * @param {object} [marketplaceFilters] – When provided (e.g. from `Marketplace.jsx`), the request uses this snapshot
 *   so `StartingDate` / `EndingDate` always match React state. Omit for legacy callers (e.g. `AdminHeader`) that rely on module exports.
 */
// Get All Products
export const GetAllProduct = (marketplaceFilters) => async (dispatch) => {
  try {
    dispatch({ type: product_Request.toString() });

    const f =
      marketplaceFilters && typeof marketplaceFilters === "object" && !Array.isArray(marketplaceFilters)
        ? marketplaceFilters
        : null;

    let Type = "";
    const activeTabRaw = f ? f.activeTab : TypeOfSelection;
    const activeTab = Number(activeTabRaw);
    if (activeTab === 0) {
      Type = "Product";
    } else if (activeTab === 1) {
      Type = "Voucher";
    } else if (activeTab === 2) {
      Type = "Media";
    }

    const scope = encodeURIComponent(
      f && f.listingScope !== undefined && f.listingScope !== null
        ? f.listingScope
        : ListingScope ?? ""
    );

    let rawSearch;
    if (f && f.liveSearchDebounced !== undefined) {
      // Marketplace list-level search from filters (supports Live/Pending tabs too)
      rawSearch = f.liveSearchDebounced ?? "";
    } else if (f) {
      rawSearch = search;
    } else {
      rawSearch =
        productListingSearchOverride !== undefined
          ? productListingSearchOverride
          : search;
    }

    const productCategory = f ? f.category : Category;
    const page = f ? f.currentPage : Page;
    const priceReversVal = f ? f.priceRevers : PriceRevers;
    const productAnalysisVal = f ? f.productAnalysis : ProductAnalysis;
    const stateVal = f ? f.state : State;
    const priceRangeVal = f ? f.priceRange : PriceRange;
    const selectedCompanyVal = f ? f.selectedCompany : SelectedCompany;
    const dateFilterVal = f ? f.date : DateFilter;
    const startingDateVal = f ? f.startingDate : StartingDateFilter;
    const endingDateVal = f ? f.endingDate : EndingDateFilter;
    const productStatusVal = f ? f.productStatus : ProductStatus;
    const pendingQueueStatusVal = f ? f.pendingQueueStatus : "";

    const encodedStartingDate = encodeURIComponent(startingDateVal || "");
    const encodedEndingDate = encodeURIComponent(endingDateVal || "");
    const encodedSelectedCompany = encodeURIComponent(selectedCompanyVal || "");
    const { data } = await axios.post(
      `AdminCompanyDetails/AllProducts?ProductCategory=${productCategory}&ProductType=${Type}&PriceRevers=${priceReversVal}&ProductAnalysis=${productAnalysisVal}&SelectedCompany=${encodedSelectedCompany}&DateFilter=${dateFilterVal}&StartingDate=${encodedStartingDate}&EndingDate=${encodedEndingDate}&ProductStatus=${productStatusVal}&PendingQueueStatus=${encodeURIComponent(
        pendingQueueStatusVal || ""
      )}&ProductLocationState=${stateVal}&PriceRange=${priceRangeVal}&page=${page}&Search=${encodeURIComponent(rawSearch || "")}&listingScope=${scope}`,
      {
        withCredentials: true,
      }
    );

    dispatch({
      type: product_Success.toString(),
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: product_Fail.toString(),
      payload: error.response.data.message,
    });
  }
};
